import { render, staticRenderFns } from "./moneyForDetails.vue?vue&type=template&id=53cec8c9&scoped=true&"
import script from "./moneyForDetails.vue?vue&type=script&lang=js&"
export * from "./moneyForDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cec8c9",
  null
  
)

export default component.exports